module.exports = __webpack_public_path__ + "img/createEducation.c3e482e2.svg";